import { type AbortPageProps } from '../../../chulak/ChulakSession';
import { getAbortVariant } from '../../../utils/abortVariants';
import EmbeddedAbortScreen from '../shared/AbortScreen';
import EmbeddedExpiredQrScreen from '../shared/ExpiredQrScreen';

/** Errors on the card. The QR code is the card's start, so an expired request fades it in place. */
export default function EmbeddedDesktopAbortPage(props: AbortPageProps) {
  const variant = props.variant ?? getAbortVariant(props.errorCode);
  if (props.app && variant === 'expired') {
    return (
      <EmbeddedExpiredQrScreen
        onRefresh={props.onRestart}
        onBack={props.onBack}
      />
    );
  }
  return <EmbeddedAbortScreen {...props} />;
}
